import { render, staticRenderFns } from "./SumSub.vue?vue&type=template&id=2a8450ee"
import script from "./SumSub.vue?vue&type=script&lang=js"
export * from "./SumSub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports